<template>
  <ul
    class="list-unstyled list-separated"
    data-test="publisher-group-list"
  >
    <b-form-checkbox-group
      id="checkbox-group-2"
      v-model="selectedGroups"
      name="flavour-2"
    >
      <template v-for="(group) in displayedPublisherGroupsOrdered">
        <li
          :key="`${group.name}-item`"
          class="list-separated-item border-bottom"
          data-test="publisher-group-list-item"
        >
          <div class="d-flex align-items-center">
            <b-form-checkbox
              :id="group.name"
              :name="group.name"
              :value="group.name"
              size="xl"
              class="publisher-checkbox"
              data-test="publisher-group-list-item-checkbox"
              :disabled="disabled"
            />
            <div
              class="text-inherit"
              data-test="publisher-group-list-item-name"
            >
              {{ group.name }}
            </div>
            <div
              class="selectgroup-button selectgroup-button-icon ml-auto"
              v-b-toggle="`accordion-${group.name}`"
              :data-test="`${group.name}-collapse-button`"
            >
              <i
                class="when-closed fa far fa-angle-down"
              />
              <i
                class="when-opened fa far fa-angle-up"
              />
            </div>
          </div>
        </li>
        <b-collapse
          class="py-4 pl-5 border-bottom"
          :id="`accordion-${group.name}`"
          :key="group.name"
          accordion="my-accordion"
          role="tabpanel"
        >
          <li
            v-for="publisher in group.publisherIds"
            :key="publisher"
            class="list-separated-item"
            data-test="publisher-group-publisher-list-item"
          >
            <div
              class="row align-items-center"
              v-if="getPublisherDetails(publisher)"
            >
              <div class="col-auto">
                <base-company-logo
                  :company="getPublisherDetails(publisher)"
                />
              </div>
              <div class="col">
                <div
                  class="text-inherit"
                  data-test="publisher-group-publisher-list-item-name"
                >
                  {{ getPublisherDetails(publisher).name }}
                </div>
                <small class="d-block item-except text-sm h-1x">
                  <a
                    :href="`http://${getPublisherDetails(publisher).domain}`"
                    target="_blank"
                  >
                    {{ getPublisherDetails(publisher).domain }}
                  </a>
                </small>
              </div>
            </div>
          </li>
        </b-collapse>
      </template>
    </b-form-checkbox-group>
  </ul>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import * as types from '@/modules/campaigns/store/types';
import BaseCompanyLogo from '@/components/BaseCompanyLogo.vue';
import helper from '@/core/helper';

export default {
  name: 'GroupPublisherSelection',
  components: { BaseCompanyLogo },
  props: {
    publishers: {
      type: Array,
      default: () => [],
    },
    publisherGroups: {
      type: Array,
      default: () => [],
    },
    displayedPublisherGroups: {
      type: Array,
      default: () => [],
    },
    selectedPublisherIds: {
      type: Array,
      default: () => [],
    },
    selectedPublisherGroups: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: false,
      selectedGroupsList: [],
    };
  },
  computed: {
    displayedPublisherGroupsOrdered() {
      const selectedGroups = this.displayedPublisherGroups.filter((group) => this.selectedPublisherGroups.includes(group.name));
      const notSelectedGroups = this.displayedPublisherGroups.filter((group) => !this.selectedPublisherGroups.includes(group.name));
      return [...selectedGroups.length > 0 ? helper.orderBy(selectedGroups, 'name') : [],
        ...notSelectedGroups.length > 0 ? helper.orderBy(notSelectedGroups, 'name') : []];
    },
    selectedGroups: {
      get() {
        return this.selectedPublisherGroups;
      },
      set(newValue) {
        this.CLEAR_PUBLISHERS();
        newValue.forEach((groupName) => {
          this.togglePublishers(groupName);
        });
        this.$emit('updateSelectedGroups', newValue);
      },
    },
  },
  methods: {
    ...mapActions('campaigns', [
      types.ADD_PUBLISHER,
    ]),
    ...mapMutations('campaigns', [
      types.CLEAR_PUBLISHERS,
    ]),
    getPublisherDetails(id) {
      return this.publishers.find((publisher) => Number(publisher.id) === Number(id));
    },
    togglePublishers(groupName) {
      const getGroup = this.publisherGroups.find((group) => group.name === groupName);
      getGroup.publisherIds.forEach((id) => {
        this.ADD_PUBLISHER(id);
      });
    },
  },
  async created() {
    if (this.selectedGroupsList.length === 0 && this.selectedPublisherIds.length === 0) {
      this.selectedGroups = this.selectedPublisherGroups;
    }
  },
};
</script>
